import React, { Component } from 'react';
import DeviceTable from '../Tables/DeviceTable';


class Dashboard extends Component {

  render() {
    return (
      <div>
        <h3 className="App-title"></h3>
        <div className='card-header'>
          <h1>Dashboard Controls</h1>
        </div>
        <DeviceTable />
      </div>
    )
  }
}

export default Dashboard;